var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-page"},[_c('basic-page',{attrs:{"pagedata":this.pageData}},[_c('p',[_vm._v(" This page doesn't exist. ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }